package br.com.htms.inspeccaocampo.data

object InspecaoCatalog {
    private var configAtual: AppConfig = AppConfig.padrao()

    fun recarregar(config: AppConfig) {
        configAtual = config
        ChecklistAlojamentoCatalog.recarregar(config)
        RelatorioFotoCatalog.recarregar(config)
    }

    fun config(): AppConfig = configAtual

    fun itensPadrao(): List<ItemVerificacao> =
        configAtual.camposAtivos().map { it.toItemVerificacao() }

    fun campoPorId(id: String): CampoConfig? =
        configAtual.campos.find { it.id == id }

    private fun CampoConfig.toItemVerificacao() = ItemVerificacao(
        id = id,
        titulo = titulo,
        fotoObrigatoriaSeSim = fotoObrigatoriaSeSim,
        fotoObrigatoriaSeNao = fotoObrigatoriaSeNao,
        obrigatorio = obrigatorio
    )
}
